import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { auditApi, notificationsApi } from '@/services/notifications';
import type { SubscriptionCreate } from '@/types/notification';

export const notifKeys = {
  catalog: ['notifications', 'catalog'] as const,
  list: ['notifications', 'list'] as const,
  audit: ['audit'] as const,
};

export function useEventCatalog() {
  return useQuery({
    queryKey: notifKeys.catalog,
    queryFn: () => notificationsApi.catalog(),
    staleTime: Number.POSITIVE_INFINITY,
  });
}

export function useSubscriptions() {
  return useQuery({
    queryKey: notifKeys.list,
    queryFn: () => notificationsApi.list(),
  });
}

export function useCreateSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: SubscriptionCreate) => notificationsApi.create(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: notifKeys.list }),
  });
}

export function useDeleteSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: notifKeys.list }),
  });
}

export function useTestSubscription() {
  return useMutation({
    mutationFn: ({
      id,
      eventId,
      message,
    }: {
      id: string;
      eventId: string;
      message: string;
    }) => notificationsApi.test(id, eventId, message),
  });
}

export function useAudit(params: { limit?: number; resource_type?: string } = {}) {
  return useQuery({
    queryKey: [...notifKeys.audit, params],
    queryFn: () => auditApi.list(params),
  });
}
